import {
    type FC
} from "react";
import type ITimelineLoadMoreProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import type {
    TimelinePartContentProps
} from "../../type";
import {
    withTimelineContext
} from "../../context";
import Pagination from "../../../pagination";

const TimelineLoadMoreContent: FC<TimelinePartContentProps<ITimelineLoadMoreProps>> = ({
    customTheme: customThemeProp,
    context
}) => {
    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    return <Pagination
        totalItems={context.isEndReached ? context.itemCount : context.totalCount}
        customTheme={customThemeProp ?? context.customTheme}
        customLocalize={context.customLocalize}
        unitTitle={localize("timeline-unit")}
        isLoading={context.isLoadingMore}
        onLoadMore={context.onLoadMore}
        loadedCount={context.itemCount}
        variant="loadMore"
    />;
};
export default withTimelineContext("LoadMore", TimelineLoadMoreContent);
